import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { WeatherForecastData, getWeatherEmoji } from '../utils';
import useStyles from '../styles';

interface DailyForecastProps extends WeatherForecastData {
  compact?: boolean;
}

const DailyForecast = ({
  date,
  minTemperature,
  maxTemperature,
  RainMm,
  RainProbability,
  eto,
  weather,
  compact = false,
}: DailyForecastProps) => {
  const classes = useStyles();
  const isRainy = weather === 'Lluvioso' || weather === 'Chubascos';
  const weatherEmoji = getWeatherEmoji(weather);

  const dateVariant = compact ? 'caption' : 'body2';
  const tempVariant = compact ? 'caption' : undefined;
  const etoVariant = compact ? 'caption' : 'body2';

  return (
    <Box
      className={classes.dailyForecastBox}
      sx={compact ? {
        minWidth: '44px',
        maxWidth: '48px',
        padding: '1px 0px',
        margin: '0 -1px',
        textAlign: 'center',
        '& .MuiTypography-root': {
          fontSize: '0.55rem',
          lineHeight: 1,
          marginBottom: '0px',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
        },
      } : {}}
    >
      <Typography variant={dateVariant}>{date ?? ''}</Typography>

      <Tooltip title={weather || 'Clima desconocido'} arrow placement="top">
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          className={`${classes.weatherText} ${isRainy ? classes.rainyWeatherText : ''}`}
          sx={compact ? {
            fontSize: '0.55rem',
            minHeight: '16px',
          } : {
            minHeight: '24px',
            fontSize: '20px',
          }}
        >
          {weatherEmoji}
        </Box>
      </Tooltip>

      <Typography
        variant={tempVariant}
        className={classes.rainText}
        sx={compact ? { fontSize: '0.55rem' } : {}}
      >
        {minTemperature !== null && maxTemperature !== null
          ? `${Math.round(minTemperature)}°. ${Math.round(maxTemperature)}°.`
          : 'N/A'}
      </Typography>

      <Typography
        variant={etoVariant}
        color="textSecondary"
        sx={compact ? { fontSize: '0.35rem' } : {}}
      >
        {`ETO: ${eto ?? 'N/A'}`}
      </Typography>

      {isRainy && (
        <Box className={classes.rainContainer}>
          <Typography
            className={classes.rainText}
            sx={compact ? { fontSize: '0.55rem' } : {}}
          >
            {`${RainMm} mm`}
          </Typography>
          <Typography
            className={classes.rainText}
            sx={compact ? { fontSize: '0.55rem' } : {}}
          >
            {`${RainProbability}%`}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default DailyForecast;
